"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Aug 02 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * SettingsConverter
 *
 * @author RV
 */


var SettingsConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SettingsConverter, _DataObjectConverter_);

  function SettingsConverter() {
    _classCallCheck(this, SettingsConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SettingsConverter).apply(this, arguments));
  }

  return SettingsConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SettingsConverter = SettingsConverter;